<app-spinner *ngIf="loadingResults"></app-spinner>

<input class="banner__input banner__input--expand"
       type="search"
       cdkFocusInitial
       autofocus="off"
       placeholder="Search Entities"
       (keydown.arrowdown)="setFirstItemActive()"
       [formControl]="searchInput">
<i class="far fa-magnifying-glass d-none--on-old banner__search-icon"></i>

<div class="results"
     (keydown)="onKeydown($event)"
     #resultsEl>

  <app-list-item class="results__entity flex flexJustify--between flexAlign--center"
                 *ngFor="let entity of searchResults"
                 [item]="entity"
                 (click)="onEntitySelected(entity)">

    <app-entity-avatar [assessmentLevel]="entity.currentAssessmentLevel"
                       [spotlightIcon]="entity.spotlightIcon"
                       [entityTypeId]="entity.entityTypeId"
                       [isUser]="entity?.linkedUserId"
                       size="sm">
    </app-entity-avatar>
    <div class="results__main">
      <app-entity-name [entity]="entity"></app-entity-name>
      <span class="results__location">{{entity?.bestAddress | cityState}}</span>
    </div>
  </app-list-item>

  <div class="results__entity results__entity--empty flex flexJustify--between flexAlign--center"
       *ngIf="noResults">
    <span>No results</span>
  </div>
</div>
